exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".template-alerts-table .onoff-switch{width:72px;height:30px;cursor:pointer}.template-alerts-table .interval-select{width:95px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/searchAlerts/TemplateAlerts/TemplateAlerts.less
// module id = 1638
// module chunks = 0